import * as types from './constants';

// Create SendbirdGroup
export const createSendbirdGroupRequest = data => (
  { type: types.CREATE_SENDBIRD_GROUP_REQUEST, payload: data }
);

export const createSendbirdGroupDone = data => (
  { type: types.CREATE_SENDBIRD_GROUP_DONE, payload: data }
);

export const createSendbirdGroupFailed = errors => (
  { type: types.CREATE_SENDBIRD_GROUP_FAILED, payload: errors }
);

export const createSendbirdGroupReset = () => (
  { type: types.CREATE_SENDBIRD_GROUP_RESET }
);